export enum SelectPlanType {
  Register = 'register',
  Upgrade = 'upgrade',
  Change = 'change-plans',
  Onboarding = 'onboarding',
}
